module.exports = __webpack_public_path__ + "static/media/ZGO__i3_sm3.80814573.png";